// removed by extract-text-webpack-plugin
module.exports = {"block":"OsGKnQJGrN05ZDKKmFEhH","innerBlock":"_3j8hCyGUKSDtPAudXihlIA","image":"_13LFZUBJfddhe6UxoFFtDR","text":"_8gfKlAC15FCvvZlN93H0w","readmore":"_2QxMNP6fQqtsv9Dv9IttW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HMSSlide/HMSSlide.module.scss
// module id = 774
// module chunks = 0